<div class="vorschau" role="group" [attr.aria-label]="'Prüfpunkte der Kategorie ' + kategorie.name">

  <header class="vorschau-kopf" *ngIf="mitKopf">
    <div class="vorschau-name">
      <span class="vorschau-farbe" *ngIf="kategorie.color" [style.background]="kategorie.color" aria-hidden="true"></span>
      <span class="vorschau-name-text">{{ kategorie.name }}</span>
      <span class="vorschau-anzahl">
        {{ anzahlPruefpunkte }} {{ anzahlPruefpunkte === 1 ? 'Prüfpunkt' : 'Prüfpunkte' }}
      </span>
    </div>
    <p class="vorschau-beschreibung" *ngIf="kategorie.beschreibung">{{ kategorie.beschreibung }}</p>
  </header>

  <div class="vorschau-struktur" *ngIf="strukturVerfuegbar">
    <section class="vorschau-abschnitt" *ngFor="let abschnitt of abschnitte">
      <h4 class="vorschau-abschnitt-titel">{{ abschnitt.name }}</h4>

      <ul class="vorschau-punkte" *ngIf="abschnitt.vorlagen.length > 0">
        <li class="vorschau-punkt" *ngFor="let vorlage of abschnitt.vorlagen">
          {{ vorlage.bezeichnung }}
        </li>
      </ul>

      <p class="vorschau-leer" *ngIf="abschnitt.vorlagen.length === 0">
        Keine Prüfpunkte in diesem Abschnitt.
      </p>
    </section>
  </div>

  <p class="vorschau-leer" *ngIf="!strukturVerfuegbar">
    Für diese Kategorie sind keine Prüfpunkte hinterlegt.
  </p>

</div>
